import { useQuery } from '@tanstack/react-query';
import { creatorDataQueries, InstagramUserAnalyticsData, PhylloUserAnalyticsData } from '@round/api';

const options = creatorDataQueries.instagramUserAnalytics.options.detail;
const utils = creatorDataQueries.instagramUserAnalytics.utils.detail;

type Config<TData> = Pick<ReturnType<typeof options>, 'enabled'> & {
    select?: (data: InstagramUserAnalyticsData) => TData;
};

export function useInstagramUserAnalytics<TData = PhylloUserAnalyticsData>(
    userId: number | undefined | null,
    config?: Config<TData>
) {
    const { data, isLoading, error, isError } = useQuery({
        ...options(userId),
        ...config,
        enabled: config?.enabled ?? !!userId,
        select: config?.select,
    });

    const errorMessage = error ? utils.getErrorMessage(error) : null;

    return { data, isLoading, error, errorMessage, isError };
}
